import axios from 'axios'
import { CADASTRAR_CUSTOS_ITINERARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarCustoItinerario (itinerarioId, empresaId, usuarioId, custosItinerario) {
  const url = `${URL}/itinerario/${itinerarioId}/empresa/${empresaId}/usuario/${usuarioId}/cadastrar-custo-itinerario`;
  return dispatch => axios.post(url, custosItinerario, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_CUSTOS_ITINERARIO,
        payload: response
      })
  );
}
